import { type MessageDescriptor } from './types.ts';

export function defineMessages<
    K extends keyof Record<string, MessageDescriptor>,
    U extends Record<K, MessageDescriptor> = Record<K, MessageDescriptor>,
>(messages: U): U {
    return messages;
}
